import React, { useEffect } from "react";
import { Box } from "@mui/material";
import ClientChartId from "./ClientChartId.jsx";

const ScenarioCharts = ({ clientJson, chart }) => {
  useEffect(() => {
    console.log("ScenarioCharts");
    console.log(chart);
  }, [chart]);

  return (
    <Box>
      {chart.map((c, i) => (
        <ClientChartId
          clientJson={clientJson}
          key={"chart" + i}
          type={c.chart}
          args={c.arg}
          scen_uuid={c.uuid ? c.uuid : clientJson.Scenario.uuid}
        />
      ))}
    </Box>
  );
};

export default ScenarioCharts;
